/**
 * Shared CV template choice.
 *
 * The CV builder and the ATS scanner must always agree on the template, so
 * the revamped CV downloads in exactly the design the user picked in the
 * builder. Stored per browser.
 */

import { CV_TEMPLATES } from "@/lib/cv-templates";

const KEY = "ndlcs.cv.templateId";

export function defaultTemplateId() {
  return CV_TEMPLATES[0]?.id ?? "ats-clean";
}

export function loadTemplateId(): string {
  if (typeof window === "undefined") return defaultTemplateId();
  try {
    const id = window.localStorage.getItem(KEY);
    if (id && CV_TEMPLATES.some((t) => t.id === id)) return id;
  } catch {
    /* storage blocked */
  }
  return defaultTemplateId();
}

export function saveTemplateId(id: string) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(KEY, id);
  } catch {
    /* storage blocked */
  }
}
